import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  LocalDate: any;
  LocalDateTime: any;
  Long: any;
  YearMonth: any;
};

export type Account = {
  __typename?: 'Account';
  accountId: Scalars['String'];
  accountName: Scalars['String'];
  contractor: Contractor;
  contractorId: Scalars['String'];
  institution: Institution;
  institutionId: Scalars['String'];
  notice: Notice;
};

export type Bill = {
  __typename?: 'Bill';
  billId: Scalars['String'];
  contractor: Contractor;
  contractorId?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['BigDecimal']>;
  endDate?: Maybe<Scalars['LocalDate']>;
  institution: Institution;
  institutionId?: Maybe<Scalars['String']>;
  janCode?: Maybe<Scalars['String']>;
  packagingPrice?: Maybe<Scalars['BigDecimal']>;
  priceType?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['LocalDate']>;
  wholesale: Wholesale;
  wholesaleId?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type BusinessCalender = {
  __typename?: 'BusinessCalender';
  businessDay?: Maybe<Scalars['LocalDate']>;
};

export type Contractor = {
  __typename?: 'Contractor';
  contractorId: Scalars['String'];
  contractorName: Scalars['String'];
  discountRate?: Maybe<Scalars['BigDecimal']>;
  discountRateSpan?: Maybe<Scalars['String']>;
};

export type DealInfo = {
  __typename?: 'DealInfo';
  discountRate?: Maybe<Scalars['BigDecimal']>;
  hasPurchaseHistory?: Maybe<Scalars['Boolean']>;
  hasPurchaseHistoryForYear?: Maybe<Scalars['Boolean']>;
  packagingPrice?: Maybe<Scalars['BigDecimal']>;
  priceType?: Maybe<Scalars['String']>;
  pricelistWholesaleName?: Maybe<Scalars['String']>;
  wholesaleId?: Maybe<Scalars['String']>;
  wholesaleName?: Maybe<Scalars['String']>;
};

export type DealInfoInput = {
  discountRate?: InputMaybe<Scalars['BigDecimal']>;
  packagingPrice?: InputMaybe<Scalars['BigDecimal']>;
  priceType?: InputMaybe<Scalars['String']>;
  wholesaleId?: InputMaybe<Scalars['String']>;
  wholesaleName?: InputMaybe<Scalars['String']>;
};

export type DraftQuotation = {
  __typename?: 'DraftQuotation';
  accountId: Scalars['String'];
  answerAt?: Maybe<Scalars['String']>;
  createAt?: Maybe<Scalars['String']>;
  details?: Maybe<Array<DraftQuotationDetail>>;
  note?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
};

export type DraftQuotationDetail = {
  __typename?: 'DraftQuotationDetail';
  accountId: Scalars['String'];
  capacity?: Maybe<Scalars['String']>;
  deals?: Maybe<Array<Maybe<DealInfo>>>;
  draftQuotationDetailId: Scalars['Long'];
  gs1Code?: Maybe<Scalars['String']>;
  janCode?: Maybe<Scalars['String']>;
  medicineId?: Maybe<Scalars['String']>;
  medicineName?: Maybe<Scalars['String']>;
  medicineType?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['BigDecimal']>;
  pricelistWholesaleName?: Maybe<Scalars['String']>;
  salesManufacturer?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  wholesaleId?: Maybe<Scalars['String']>;
  wholesaleName?: Maybe<Scalars['String']>;
  yjCode?: Maybe<Scalars['String']>;
};

export type DraftQuotationDetailAddCommand = {
  capacity: Scalars['String'];
  gs1Code?: InputMaybe<Scalars['String']>;
  janCode: Scalars['String'];
  medicineId?: InputMaybe<Scalars['String']>;
  medicineName: Scalars['String'];
  medicineType?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  salesManufacturer: Scalars['String'];
  yjCode?: InputMaybe<Scalars['String']>;
};

export type DrugPrice = {
  __typename?: 'DrugPrice';
  endDate?: Maybe<Scalars['LocalDate']>;
  janCode?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['BigDecimal']>;
  priceId: Scalars['String'];
  startDate?: Maybe<Scalars['LocalDate']>;
  year?: Maybe<Scalars['Int']>;
};

export type Institution = {
  __typename?: 'Institution';
  conclusionDate?: Maybe<Scalars['LocalDate']>;
  contractorId: Scalars['String'];
  institutionId: Scalars['String'];
  institutionName: Scalars['String'];
};

export enum MatchType {
  All = 'ALL',
  Partial = 'PARTIAL',
  Prefix = 'PREFIX',
  Suffix = 'SUFFIX'
}

export type MedicineDetailResult = {
  __typename?: 'MedicineDetailResult';
  authorizedGeneric?: Maybe<Scalars['Int']>;
  biosimilar?: Maybe<Scalars['Int']>;
  capacity?: Maybe<Scalars['String']>;
  commonName?: Maybe<Scalars['String']>;
  currentEndDate?: Maybe<Scalars['LocalDate']>;
  currentPrice?: Maybe<Scalars['BigDecimal']>;
  currentPriceId?: Maybe<Scalars['String']>;
  currentStartDate?: Maybe<Scalars['LocalDate']>;
  currentYear?: Maybe<Scalars['Int']>;
  deals?: Maybe<Array<Maybe<DealInfo>>>;
  drugCategoryName?: Maybe<Scalars['String']>;
  generic?: Maybe<Scalars['Int']>;
  gs1Code?: Maybe<Scalars['String']>;
  janCode?: Maybe<Scalars['String']>;
  medicineId?: Maybe<Scalars['String']>;
  medicineName?: Maybe<Scalars['String']>;
  medicineType?: Maybe<Scalars['String']>;
  previousEndDate?: Maybe<Scalars['LocalDate']>;
  previousPrice?: Maybe<Scalars['BigDecimal']>;
  previousPriceId?: Maybe<Scalars['String']>;
  previousStartDate?: Maybe<Scalars['LocalDate']>;
  previousYear?: Maybe<Scalars['Int']>;
  saleStartExpectedDate?: Maybe<Scalars['String']>;
  salesManufacturer?: Maybe<Scalars['String']>;
  stopExpectedDate?: Maybe<Scalars['String']>;
  yjCode?: Maybe<Scalars['String']>;
};

export type MedicineDetailsResult = {
  __typename?: 'MedicineDetailsResult';
  count: Scalars['Int'];
  medicines?: Maybe<Array<MedicineDetailResult>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addDraftQuotationDetail?: Maybe<DraftQuotation>;
  cancelQuotationDetail?: Maybe<Quotation>;
  deleteDraftQuotation?: Maybe<Scalars['Boolean']>;
  deleteDraftQuotationDetail?: Maybe<DraftQuotation>;
  login: Account;
  logout?: Maybe<Scalars['Boolean']>;
  submitQuotation?: Maybe<Scalars['Boolean']>;
  updateDraftQuotation?: Maybe<DraftQuotation>;
  updateDraftQuotationDetail?: Maybe<DraftQuotation>;
  updateQuotationDetailChecked?: Maybe<Quotation>;
};


export type MutationAddDraftQuotationDetailArgs = {
  commands: Array<DraftQuotationDetailAddCommand>;
};


export type MutationCancelQuotationDetailArgs = {
  quotationDetailId: Scalars['String'];
  quotationId: Scalars['String'];
};


export type MutationDeleteDraftQuotationDetailArgs = {
  draftQuotationDetailId: Scalars['Long'];
};


export type MutationLoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationSubmitQuotationArgs = {
  note?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDraftQuotationArgs = {
  note?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDraftQuotationDetailArgs = {
  draftQuotationDetailId: Scalars['Long'];
  note?: InputMaybe<Scalars['String']>;
  wholesaleId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateQuotationDetailCheckedArgs = {
  checked: Scalars['Int'];
  quotationDetailId: Scalars['String'];
  quotationId: Scalars['String'];
};

export type Notice = {
  __typename?: 'Notice';
  notice: Scalars['String'];
  noticeAt?: Maybe<Scalars['LocalDate']>;
  pricelistUpdate?: Maybe<Scalars['LocalDateTime']>;
};

export type Query = {
  __typename?: 'Query';
  draftQuotation?: Maybe<DraftQuotation>;
  medicineDetails?: Maybe<MedicineDetailsResult>;
  quotation: Quotation;
  quotations?: Maybe<QuotationsResult>;
  selectBusinessCalender: BusinessCalender;
  whoAmI?: Maybe<Account>;
  wholesales?: Maybe<Array<Wholesale>>;
};


export type QueryMedicineDetailsArgs = {
  capacity?: InputMaybe<Scalars['String']>;
  commonName?: InputMaybe<Scalars['String']>;
  currentYear?: InputMaybe<Scalars['Int']>;
  deals?: InputMaybe<Array<InputMaybe<DealInfoInput>>>;
  drugCategoryName?: InputMaybe<Scalars['String']>;
  excludeProcessed?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['String']>;
  gs1Code?: InputMaybe<Scalars['String']>;
  hasNoPurchaseHistory?: InputMaybe<Scalars['Boolean']>;
  hasPackagingPrice?: InputMaybe<Scalars['Boolean']>;
  hasPurchaseHistory?: InputMaybe<Scalars['Boolean']>;
  isForPriceDisplay?: InputMaybe<Scalars['Boolean']>;
  janCode?: InputMaybe<Scalars['String']>;
  matchType?: InputMaybe<MatchType>;
  medicineName?: InputMaybe<Scalars['String']>;
  medicineTypes?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  previousYear?: InputMaybe<Scalars['Int']>;
  salesManufacturer?: InputMaybe<Scalars['String']>;
  searchOperation?: InputMaybe<Scalars['String']>;
  yjCode?: InputMaybe<Scalars['String']>;
};


export type QueryQuotationArgs = {
  quotationId: Scalars['String'];
};


export type QueryQuotationsArgs = {
  capacity?: InputMaybe<Scalars['String']>;
  commonName?: InputMaybe<Scalars['String']>;
  drugCategoryName?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  gs1Code?: InputMaybe<Scalars['String']>;
  janCode?: InputMaybe<Scalars['String']>;
  matchType?: InputMaybe<MatchType>;
  medicineName?: InputMaybe<Scalars['String']>;
  medicineTypes?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  salesManufacturer?: InputMaybe<Scalars['String']>;
  searchOperation?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  yjCode?: InputMaybe<Scalars['String']>;
};

export type Quotation = {
  __typename?: 'Quotation';
  answerAt: Scalars['LocalDate'];
  contractorId: Scalars['String'];
  createAt: Scalars['LocalDateTime'];
  details?: Maybe<Array<QuotationDetail>>;
  institutionId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  quotationId: Scalars['String'];
  quotationNo: Scalars['String'];
  quotationStatus: Scalars['String'];
  requestAt: Scalars['LocalDate'];
  summary?: Maybe<QuotationDetailSummary>;
};

export type QuotationDetail = {
  __typename?: 'QuotationDetail';
  capacity: Scalars['String'];
  checked: Scalars['Int'];
  deals?: Maybe<Array<Maybe<DealInfo>>>;
  gs1Code?: Maybe<Scalars['String']>;
  janCode: Scalars['String'];
  medicineId?: Maybe<Scalars['String']>;
  medicineName: Scalars['String'];
  medicineType?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['BigDecimal']>;
  pricelistWholesaleName?: Maybe<Scalars['String']>;
  quotationDetailId: Scalars['String'];
  quotationDetailStatus?: Maybe<Scalars['String']>;
  quotationId: Scalars['String'];
  salesManufacturer: Scalars['String'];
  sort: Scalars['Int'];
  wholesaleId?: Maybe<Scalars['String']>;
  wholesaleName?: Maybe<Scalars['String']>;
  yjCode?: Maybe<Scalars['String']>;
};

export type QuotationDetailSummary = {
  __typename?: 'QuotationDetailSummary';
  detailCount: Scalars['Int'];
  firstDetail: QuotationDetail;
};

export type QuotationsResult = {
  __typename?: 'QuotationsResult';
  count: Scalars['Int'];
  quotations?: Maybe<Array<Quotation>>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
  Status = 'STATUS'
}

export type Wholesale = {
  __typename?: 'Wholesale';
  pricelistWholesaleName?: Maybe<Scalars['String']>;
  wholesaleId: Scalars['String'];
  wholesaleName: Scalars['String'];
};

export type AccountFragment = { __typename?: 'Account', accountId: string, contractor: { __typename?: 'Contractor', contractorName: string, discountRate?: any | null, discountRateSpan?: string | null }, institution: { __typename?: 'Institution', institutionName: string, conclusionDate?: any | null }, notice: { __typename?: 'Notice', notice: string, noticeAt?: any | null, pricelistUpdate?: any | null } };

export type WholesaleFragment = { __typename?: 'Wholesale', wholesaleId: string, wholesaleName: string, pricelistWholesaleName?: string | null };

export type QuotationFragment = { __typename?: 'Quotation', quotationId: string, quotationNo: string, quotationStatus: string, orderStatus?: string | null, requestAt: any, createAt: any, answerAt: any, note?: string | null, pdfUrl?: string | null };

export type QuotationDetailFragment = { __typename?: 'QuotationDetail', quotationDetailId: string, quotationId: string, medicineId?: string | null, wholesaleId?: string | null, sort: number, janCode: string, medicineName: string, salesManufacturer: string, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity: string, price?: any | null, note?: string | null, quotationDetailStatus?: string | null, checked: number, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null };

export type DraftQuotationWithDetailsFragment = { __typename?: 'DraftQuotation', answerAt?: string | null, orderStatus?: string | null, note?: string | null, details?: Array<{ __typename?: 'DraftQuotationDetail', draftQuotationDetailId: any, accountId: string, medicineId?: string | null, wholesaleId?: string | null, sort?: number | null, janCode?: string | null, medicineName?: string | null, salesManufacturer?: string | null, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity?: string | null, price?: any | null, note?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null }> | null };

export type DraftQuotationDetailFragment = { __typename?: 'DraftQuotationDetail', draftQuotationDetailId: any, accountId: string, medicineId?: string | null, wholesaleId?: string | null, sort?: number | null, janCode?: string | null, medicineName?: string | null, salesManufacturer?: string | null, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity?: string | null, price?: any | null, note?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null };

export type BusinessCalenderFragment = { __typename?: 'BusinessCalender', businessDay?: any | null };

export type MedicineDetailResultFragment = { __typename?: 'MedicineDetailResult', medicineId?: string | null, medicineType?: string | null, generic?: number | null, authorizedGeneric?: number | null, biosimilar?: number | null, medicineName?: string | null, capacity?: string | null, commonName?: string | null, drugCategoryName?: string | null, salesManufacturer?: string | null, saleStartExpectedDate?: string | null, stopExpectedDate?: string | null, janCode?: string | null, yjCode?: string | null, gs1Code?: string | null, currentYear?: number | null, currentStartDate?: any | null, currentEndDate?: any | null, currentPriceId?: string | null, currentPrice?: any | null, previousYear?: number | null, previousStartDate?: any | null, previousEndDate?: any | null, previousPriceId?: string | null, previousPrice?: any | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null };

export type MedicineDetailsResultFragment = { __typename?: 'MedicineDetailsResult', count: number, medicines?: Array<{ __typename?: 'MedicineDetailResult', medicineId?: string | null, medicineType?: string | null, generic?: number | null, authorizedGeneric?: number | null, biosimilar?: number | null, medicineName?: string | null, capacity?: string | null, commonName?: string | null, drugCategoryName?: string | null, salesManufacturer?: string | null, saleStartExpectedDate?: string | null, stopExpectedDate?: string | null, janCode?: string | null, yjCode?: string | null, gs1Code?: string | null, currentYear?: number | null, currentStartDate?: any | null, currentEndDate?: any | null, currentPriceId?: string | null, currentPrice?: any | null, previousYear?: number | null, previousStartDate?: any | null, previousEndDate?: any | null, previousPriceId?: string | null, previousPrice?: any | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null }> | null };

export type QuotationsResultFragment = { __typename?: 'QuotationsResult', count: number, quotations?: Array<{ __typename?: 'Quotation', quotationId: string, quotationNo: string, quotationStatus: string, orderStatus?: string | null, requestAt: any, createAt: any, answerAt: any, note?: string | null, pdfUrl?: string | null, summary?: { __typename?: 'QuotationDetailSummary', detailCount: number, firstDetail: { __typename?: 'QuotationDetail', quotationDetailId: string, quotationId: string, medicineId?: string | null, wholesaleId?: string | null, sort: number, janCode: string, medicineName: string, salesManufacturer: string, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity: string, price?: any | null, note?: string | null, quotationDetailStatus?: string | null, checked: number, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null } } | null }> | null };

export type WhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoAmIQuery = { __typename?: 'Query', whoAmI?: { __typename?: 'Account', accountId: string, contractor: { __typename?: 'Contractor', contractorName: string, discountRate?: any | null, discountRateSpan?: string | null }, institution: { __typename?: 'Institution', institutionName: string, conclusionDate?: any | null }, notice: { __typename?: 'Notice', notice: string, noticeAt?: any | null, pricelistUpdate?: any | null } } | null };

export type MedicineDetailsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['String']>;
  medicineTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  matchType?: InputMaybe<MatchType>;
  janCode?: InputMaybe<Scalars['String']>;
  medicineName?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['String']>;
  commonName?: InputMaybe<Scalars['String']>;
  yjCode?: InputMaybe<Scalars['String']>;
  gs1Code?: InputMaybe<Scalars['String']>;
  salesManufacturer?: InputMaybe<Scalars['String']>;
  drugCategoryName?: InputMaybe<Scalars['String']>;
  currentYear?: InputMaybe<Scalars['Int']>;
  previousYear?: InputMaybe<Scalars['Int']>;
  searchOperation?: InputMaybe<Scalars['String']>;
  excludeProcessed?: InputMaybe<Scalars['Boolean']>;
  deals?: InputMaybe<Array<InputMaybe<DealInfoInput>> | InputMaybe<DealInfoInput>>;
  hasPurchaseHistory?: InputMaybe<Scalars['Boolean']>;
  hasNoPurchaseHistory?: InputMaybe<Scalars['Boolean']>;
  isForPriceDisplay?: InputMaybe<Scalars['Boolean']>;
  hasPackagingPrice?: InputMaybe<Scalars['Boolean']>;
}>;


export type MedicineDetailsQuery = { __typename?: 'Query', medicineDetails?: { __typename?: 'MedicineDetailsResult', count: number, medicines?: Array<{ __typename?: 'MedicineDetailResult', medicineId?: string | null, medicineType?: string | null, generic?: number | null, authorizedGeneric?: number | null, biosimilar?: number | null, medicineName?: string | null, capacity?: string | null, commonName?: string | null, drugCategoryName?: string | null, salesManufacturer?: string | null, saleStartExpectedDate?: string | null, stopExpectedDate?: string | null, janCode?: string | null, yjCode?: string | null, gs1Code?: string | null, currentYear?: number | null, currentStartDate?: any | null, currentEndDate?: any | null, currentPriceId?: string | null, currentPrice?: any | null, previousYear?: number | null, previousStartDate?: any | null, previousEndDate?: any | null, previousPriceId?: string | null, previousPrice?: any | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null }> | null } | null };

export type QuotationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['String']>;
  medicineName?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['String']>;
  commonName?: InputMaybe<Scalars['String']>;
  salesManufacturer?: InputMaybe<Scalars['String']>;
  janCode?: InputMaybe<Scalars['String']>;
  yjCode?: InputMaybe<Scalars['String']>;
  gs1Code?: InputMaybe<Scalars['String']>;
  drugCategoryName?: InputMaybe<Scalars['String']>;
  searchOperation?: InputMaybe<Scalars['String']>;
  medicineTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  matchType?: InputMaybe<MatchType>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type QuotationsQuery = { __typename?: 'Query', quotations?: { __typename?: 'QuotationsResult', count: number, quotations?: Array<{ __typename?: 'Quotation', quotationId: string, quotationNo: string, quotationStatus: string, orderStatus?: string | null, requestAt: any, createAt: any, answerAt: any, note?: string | null, pdfUrl?: string | null, summary?: { __typename?: 'QuotationDetailSummary', detailCount: number, firstDetail: { __typename?: 'QuotationDetail', quotationDetailId: string, quotationId: string, medicineId?: string | null, wholesaleId?: string | null, sort: number, janCode: string, medicineName: string, salesManufacturer: string, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity: string, price?: any | null, note?: string | null, quotationDetailStatus?: string | null, checked: number, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null } } | null }> | null } | null };

export type QuotationQueryVariables = Exact<{
  quotationId: Scalars['String'];
}>;


export type QuotationQuery = { __typename?: 'Query', quotation: { __typename?: 'Quotation', quotationId: string, quotationNo: string, quotationStatus: string, orderStatus?: string | null, requestAt: any, createAt: any, answerAt: any, note?: string | null, pdfUrl?: string | null, details?: Array<{ __typename?: 'QuotationDetail', quotationDetailId: string, quotationId: string, medicineId?: string | null, wholesaleId?: string | null, sort: number, janCode: string, medicineName: string, salesManufacturer: string, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity: string, price?: any | null, note?: string | null, quotationDetailStatus?: string | null, checked: number, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null }> | null }, wholesales?: Array<{ __typename?: 'Wholesale', wholesaleId: string, wholesaleName: string, pricelistWholesaleName?: string | null }> | null };

export type DraftQuotationPageQueryVariables = Exact<{ [key: string]: never; }>;


export type DraftQuotationPageQuery = { __typename?: 'Query', draftQuotation?: { __typename?: 'DraftQuotation', answerAt?: string | null, orderStatus?: string | null, note?: string | null, details?: Array<{ __typename?: 'DraftQuotationDetail', draftQuotationDetailId: any, accountId: string, medicineId?: string | null, wholesaleId?: string | null, sort?: number | null, janCode?: string | null, medicineName?: string | null, salesManufacturer?: string | null, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity?: string | null, price?: any | null, note?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null }> | null } | null, wholesales?: Array<{ __typename?: 'Wholesale', wholesaleId: string, wholesaleName: string, pricelistWholesaleName?: string | null }> | null, selectBusinessCalender: { __typename?: 'BusinessCalender', businessDay?: any | null } };

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'Account', accountId: string, contractor: { __typename?: 'Contractor', contractorName: string, discountRate?: any | null, discountRateSpan?: string | null }, institution: { __typename?: 'Institution', institutionName: string, conclusionDate?: any | null }, notice: { __typename?: 'Notice', notice: string, noticeAt?: any | null, pricelistUpdate?: any | null } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: boolean | null };

export type AddDraftQuotationDetailMutationVariables = Exact<{
  commands: Array<DraftQuotationDetailAddCommand> | DraftQuotationDetailAddCommand;
}>;


export type AddDraftQuotationDetailMutation = { __typename?: 'Mutation', addDraftQuotationDetail?: { __typename?: 'DraftQuotation', answerAt?: string | null, orderStatus?: string | null, note?: string | null, details?: Array<{ __typename?: 'DraftQuotationDetail', draftQuotationDetailId: any, accountId: string, medicineId?: string | null, wholesaleId?: string | null, sort?: number | null, janCode?: string | null, medicineName?: string | null, salesManufacturer?: string | null, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity?: string | null, price?: any | null, note?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null }> | null } | null };

export type UpdateDraftQuotationMutationVariables = Exact<{
  note?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDraftQuotationMutation = { __typename?: 'Mutation', updateDraftQuotation?: { __typename?: 'DraftQuotation', answerAt?: string | null, orderStatus?: string | null, note?: string | null, details?: Array<{ __typename?: 'DraftQuotationDetail', draftQuotationDetailId: any, accountId: string, medicineId?: string | null, wholesaleId?: string | null, sort?: number | null, janCode?: string | null, medicineName?: string | null, salesManufacturer?: string | null, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity?: string | null, price?: any | null, note?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null }> | null } | null };

export type DeleteDraftQuotationMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteDraftQuotationMutation = { __typename?: 'Mutation', deleteDraftQuotation?: boolean | null };

export type UpdateDraftQuotationDetailMutationVariables = Exact<{
  draftQuotationDetailId: Scalars['Long'];
  wholesaleId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDraftQuotationDetailMutation = { __typename?: 'Mutation', updateDraftQuotationDetail?: { __typename?: 'DraftQuotation', answerAt?: string | null, orderStatus?: string | null, note?: string | null, details?: Array<{ __typename?: 'DraftQuotationDetail', draftQuotationDetailId: any, accountId: string, medicineId?: string | null, wholesaleId?: string | null, sort?: number | null, janCode?: string | null, medicineName?: string | null, salesManufacturer?: string | null, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity?: string | null, price?: any | null, note?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null }> | null } | null };

export type DeleteDraftQuotationDetailMutationVariables = Exact<{
  draftQuotationDetailId: Scalars['Long'];
}>;


export type DeleteDraftQuotationDetailMutation = { __typename?: 'Mutation', deleteDraftQuotationDetail?: { __typename?: 'DraftQuotation', answerAt?: string | null, orderStatus?: string | null, note?: string | null, details?: Array<{ __typename?: 'DraftQuotationDetail', draftQuotationDetailId: any, accountId: string, medicineId?: string | null, wholesaleId?: string | null, sort?: number | null, janCode?: string | null, medicineName?: string | null, salesManufacturer?: string | null, yjCode?: string | null, gs1Code?: string | null, medicineType?: string | null, capacity?: string | null, price?: any | null, note?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, deals?: Array<{ __typename?: 'DealInfo', wholesaleId?: string | null, wholesaleName?: string | null, pricelistWholesaleName?: string | null, priceType?: string | null, packagingPrice?: any | null, discountRate?: any | null, hasPurchaseHistory?: boolean | null, hasPurchaseHistoryForYear?: boolean | null } | null> | null }> | null } | null };

export type SubmitQuotationMutationVariables = Exact<{
  note?: InputMaybe<Scalars['String']>;
}>;


export type SubmitQuotationMutation = { __typename?: 'Mutation', submitQuotation?: boolean | null };

export type CancelQuotationDetailMutationVariables = Exact<{
  quotationId: Scalars['String'];
  quotationDetailId: Scalars['String'];
}>;


export type CancelQuotationDetailMutation = { __typename?: 'Mutation', cancelQuotationDetail?: { __typename?: 'Quotation', quotationId: string, quotationNo: string, quotationStatus: string, orderStatus?: string | null, requestAt: any, createAt: any, answerAt: any, note?: string | null, pdfUrl?: string | null } | null };

export type WholesalesQueryVariables = Exact<{ [key: string]: never; }>;


export type WholesalesQuery = { __typename?: 'Query', wholesales?: Array<{ __typename?: 'Wholesale', wholesaleId: string, wholesaleName: string, pricelistWholesaleName?: string | null }> | null };

export type UpdateQuotationDetailCheckedMutationVariables = Exact<{
  quotationId: Scalars['String'];
  quotationDetailId: Scalars['String'];
  checked: Scalars['Int'];
}>;


export type UpdateQuotationDetailCheckedMutation = { __typename?: 'Mutation', updateQuotationDetailChecked?: { __typename?: 'Quotation', quotationId: string, quotationNo: string, quotationStatus: string, orderStatus?: string | null, requestAt: any, createAt: any, answerAt: any, note?: string | null, pdfUrl?: string | null } | null };

export const AccountFragmentDoc = gql`
    fragment Account on Account {
  accountId
  contractor {
    contractorName
    discountRate
    discountRateSpan
  }
  institution {
    institutionName
    conclusionDate
  }
  notice {
    notice
    noticeAt
    pricelistUpdate
  }
}
    `;
export const WholesaleFragmentDoc = gql`
    fragment Wholesale on Wholesale {
  wholesaleId
  wholesaleName
  pricelistWholesaleName
}
    `;
export const DraftQuotationDetailFragmentDoc = gql`
    fragment DraftQuotationDetail on DraftQuotationDetail {
  draftQuotationDetailId
  accountId
  medicineId
  wholesaleId
  sort
  janCode
  medicineName
  salesManufacturer
  yjCode
  gs1Code
  medicineType
  capacity
  price
  note
  wholesaleName
  pricelistWholesaleName
  deals {
    wholesaleId
    wholesaleName
    pricelistWholesaleName
    priceType
    packagingPrice
    discountRate
    hasPurchaseHistory
    hasPurchaseHistoryForYear
  }
}
    `;
export const DraftQuotationWithDetailsFragmentDoc = gql`
    fragment DraftQuotationWithDetails on DraftQuotation {
  answerAt
  orderStatus
  note
  details {
    ...DraftQuotationDetail
  }
}
    ${DraftQuotationDetailFragmentDoc}`;
export const BusinessCalenderFragmentDoc = gql`
    fragment BusinessCalender on BusinessCalender {
  businessDay
}
    `;
export const MedicineDetailResultFragmentDoc = gql`
    fragment MedicineDetailResult on MedicineDetailResult {
  medicineId
  medicineType
  generic
  authorizedGeneric
  biosimilar
  medicineName
  capacity
  commonName
  drugCategoryName
  salesManufacturer
  saleStartExpectedDate
  stopExpectedDate
  janCode
  yjCode
  gs1Code
  currentYear
  currentStartDate
  currentEndDate
  currentPriceId
  currentPrice
  previousYear
  previousStartDate
  previousEndDate
  previousPriceId
  previousPrice
  deals {
    wholesaleId
    wholesaleName
    pricelistWholesaleName
    priceType
    packagingPrice
    discountRate
    hasPurchaseHistory
    hasPurchaseHistoryForYear
  }
}
    `;
export const MedicineDetailsResultFragmentDoc = gql`
    fragment MedicineDetailsResult on MedicineDetailsResult {
  count
  medicines {
    ...MedicineDetailResult
  }
}
    ${MedicineDetailResultFragmentDoc}`;
export const QuotationFragmentDoc = gql`
    fragment Quotation on Quotation {
  quotationId
  quotationNo
  quotationStatus
  orderStatus
  requestAt
  createAt
  answerAt
  note
  pdfUrl
}
    `;
export const QuotationDetailFragmentDoc = gql`
    fragment QuotationDetail on QuotationDetail {
  quotationDetailId
  quotationId
  medicineId
  wholesaleId
  sort
  janCode
  medicineName
  salesManufacturer
  yjCode
  gs1Code
  medicineType
  capacity
  price
  note
  quotationDetailStatus
  checked
  wholesaleName
  pricelistWholesaleName
  deals {
    wholesaleId
    wholesaleName
    pricelistWholesaleName
    priceType
    packagingPrice
    discountRate
    hasPurchaseHistory
    hasPurchaseHistoryForYear
  }
}
    `;
export const QuotationsResultFragmentDoc = gql`
    fragment QuotationsResult on QuotationsResult {
  count
  quotations {
    ...Quotation
    summary {
      detailCount
      firstDetail {
        ...QuotationDetail
      }
    }
  }
}
    ${QuotationFragmentDoc}
${QuotationDetailFragmentDoc}`;
export const WhoAmIDocument = gql`
    query WhoAmI {
  whoAmI {
    ...Account
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useWhoAmIQuery__
 *
 * To run a query within a React component, call `useWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoAmIQuery(baseOptions?: Apollo.QueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
      }
export function useWhoAmILazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export type WhoAmIQueryHookResult = ReturnType<typeof useWhoAmIQuery>;
export type WhoAmILazyQueryHookResult = ReturnType<typeof useWhoAmILazyQuery>;
export type WhoAmIQueryResult = Apollo.QueryResult<WhoAmIQuery, WhoAmIQueryVariables>;
export const MedicineDetailsDocument = gql`
    query MedicineDetails($page: Int, $pageSize: Int, $filter: String, $medicineTypes: [String!], $matchType: MatchType, $janCode: String, $medicineName: String, $capacity: String, $commonName: String, $yjCode: String, $gs1Code: String, $salesManufacturer: String, $drugCategoryName: String, $currentYear: Int, $previousYear: Int, $searchOperation: String, $excludeProcessed: Boolean, $deals: [DealInfoInput], $hasPurchaseHistory: Boolean, $hasNoPurchaseHistory: Boolean, $isForPriceDisplay: Boolean, $hasPackagingPrice: Boolean) {
  medicineDetails(
    page: $page
    pageSize: $pageSize
    filter: $filter
    medicineTypes: $medicineTypes
    matchType: $matchType
    janCode: $janCode
    medicineName: $medicineName
    capacity: $capacity
    commonName: $commonName
    yjCode: $yjCode
    gs1Code: $gs1Code
    salesManufacturer: $salesManufacturer
    drugCategoryName: $drugCategoryName
    currentYear: $currentYear
    previousYear: $previousYear
    searchOperation: $searchOperation
    excludeProcessed: $excludeProcessed
    deals: $deals
    hasPurchaseHistory: $hasPurchaseHistory
    hasNoPurchaseHistory: $hasNoPurchaseHistory
    isForPriceDisplay: $isForPriceDisplay
    hasPackagingPrice: $hasPackagingPrice
  ) {
    ...MedicineDetailsResult
  }
}
    ${MedicineDetailsResultFragmentDoc}`;

/**
 * __useMedicineDetailsQuery__
 *
 * To run a query within a React component, call `useMedicineDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicineDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicineDetailsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *      medicineTypes: // value for 'medicineTypes'
 *      matchType: // value for 'matchType'
 *      janCode: // value for 'janCode'
 *      medicineName: // value for 'medicineName'
 *      capacity: // value for 'capacity'
 *      commonName: // value for 'commonName'
 *      yjCode: // value for 'yjCode'
 *      gs1Code: // value for 'gs1Code'
 *      salesManufacturer: // value for 'salesManufacturer'
 *      drugCategoryName: // value for 'drugCategoryName'
 *      currentYear: // value for 'currentYear'
 *      previousYear: // value for 'previousYear'
 *      searchOperation: // value for 'searchOperation'
 *      excludeProcessed: // value for 'excludeProcessed'
 *      deals: // value for 'deals'
 *      hasPurchaseHistory: // value for 'hasPurchaseHistory'
 *      hasNoPurchaseHistory: // value for 'hasNoPurchaseHistory'
 *      isForPriceDisplay: // value for 'isForPriceDisplay'
 *      hasPackagingPrice: // value for 'hasPackagingPrice'
 *   },
 * });
 */
export function useMedicineDetailsQuery(baseOptions?: Apollo.QueryHookOptions<MedicineDetailsQuery, MedicineDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicineDetailsQuery, MedicineDetailsQueryVariables>(MedicineDetailsDocument, options);
      }
export function useMedicineDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicineDetailsQuery, MedicineDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicineDetailsQuery, MedicineDetailsQueryVariables>(MedicineDetailsDocument, options);
        }
export type MedicineDetailsQueryHookResult = ReturnType<typeof useMedicineDetailsQuery>;
export type MedicineDetailsLazyQueryHookResult = ReturnType<typeof useMedicineDetailsLazyQuery>;
export type MedicineDetailsQueryResult = Apollo.QueryResult<MedicineDetailsQuery, MedicineDetailsQueryVariables>;
export const QuotationsDocument = gql`
    query Quotations($page: Int, $pageSize: Int, $filter: String, $medicineName: String, $capacity: String, $commonName: String, $salesManufacturer: String, $janCode: String, $yjCode: String, $gs1Code: String, $drugCategoryName: String, $searchOperation: String, $medicineTypes: [String!], $matchType: MatchType, $sortOrder: SortOrder) {
  quotations(
    page: $page
    pageSize: $pageSize
    filter: $filter
    medicineName: $medicineName
    capacity: $capacity
    commonName: $commonName
    salesManufacturer: $salesManufacturer
    janCode: $janCode
    yjCode: $yjCode
    gs1Code: $gs1Code
    drugCategoryName: $drugCategoryName
    searchOperation: $searchOperation
    medicineTypes: $medicineTypes
    matchType: $matchType
    sortOrder: $sortOrder
  ) {
    ...QuotationsResult
  }
}
    ${QuotationsResultFragmentDoc}`;

/**
 * __useQuotationsQuery__
 *
 * To run a query within a React component, call `useQuotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *      medicineName: // value for 'medicineName'
 *      capacity: // value for 'capacity'
 *      commonName: // value for 'commonName'
 *      salesManufacturer: // value for 'salesManufacturer'
 *      janCode: // value for 'janCode'
 *      yjCode: // value for 'yjCode'
 *      gs1Code: // value for 'gs1Code'
 *      drugCategoryName: // value for 'drugCategoryName'
 *      searchOperation: // value for 'searchOperation'
 *      medicineTypes: // value for 'medicineTypes'
 *      matchType: // value for 'matchType'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useQuotationsQuery(baseOptions?: Apollo.QueryHookOptions<QuotationsQuery, QuotationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotationsQuery, QuotationsQueryVariables>(QuotationsDocument, options);
      }
export function useQuotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotationsQuery, QuotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotationsQuery, QuotationsQueryVariables>(QuotationsDocument, options);
        }
export type QuotationsQueryHookResult = ReturnType<typeof useQuotationsQuery>;
export type QuotationsLazyQueryHookResult = ReturnType<typeof useQuotationsLazyQuery>;
export type QuotationsQueryResult = Apollo.QueryResult<QuotationsQuery, QuotationsQueryVariables>;
export const QuotationDocument = gql`
    query Quotation($quotationId: String!) {
  quotation(quotationId: $quotationId) {
    ...Quotation
    details {
      ...QuotationDetail
    }
  }
  wholesales {
    ...Wholesale
  }
}
    ${QuotationFragmentDoc}
${QuotationDetailFragmentDoc}
${WholesaleFragmentDoc}`;

/**
 * __useQuotationQuery__
 *
 * To run a query within a React component, call `useQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationQuery({
 *   variables: {
 *      quotationId: // value for 'quotationId'
 *   },
 * });
 */
export function useQuotationQuery(baseOptions: Apollo.QueryHookOptions<QuotationQuery, QuotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotationQuery, QuotationQueryVariables>(QuotationDocument, options);
      }
export function useQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotationQuery, QuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotationQuery, QuotationQueryVariables>(QuotationDocument, options);
        }
export type QuotationQueryHookResult = ReturnType<typeof useQuotationQuery>;
export type QuotationLazyQueryHookResult = ReturnType<typeof useQuotationLazyQuery>;
export type QuotationQueryResult = Apollo.QueryResult<QuotationQuery, QuotationQueryVariables>;
export const DraftQuotationPageDocument = gql`
    query DraftQuotationPage {
  draftQuotation {
    ...DraftQuotationWithDetails
  }
  wholesales {
    ...Wholesale
  }
  selectBusinessCalender {
    ...BusinessCalender
  }
}
    ${DraftQuotationWithDetailsFragmentDoc}
${WholesaleFragmentDoc}
${BusinessCalenderFragmentDoc}`;

/**
 * __useDraftQuotationPageQuery__
 *
 * To run a query within a React component, call `useDraftQuotationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftQuotationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftQuotationPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useDraftQuotationPageQuery(baseOptions?: Apollo.QueryHookOptions<DraftQuotationPageQuery, DraftQuotationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftQuotationPageQuery, DraftQuotationPageQueryVariables>(DraftQuotationPageDocument, options);
      }
export function useDraftQuotationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftQuotationPageQuery, DraftQuotationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftQuotationPageQuery, DraftQuotationPageQueryVariables>(DraftQuotationPageDocument, options);
        }
export type DraftQuotationPageQueryHookResult = ReturnType<typeof useDraftQuotationPageQuery>;
export type DraftQuotationPageLazyQueryHookResult = ReturnType<typeof useDraftQuotationPageLazyQuery>;
export type DraftQuotationPageQueryResult = Apollo.QueryResult<DraftQuotationPageQuery, DraftQuotationPageQueryVariables>;
export const LoginDocument = gql`
    mutation Login($username: String!, $password: String!) {
  login(username: $username, password: $password) {
    ...Account
  }
}
    ${AccountFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const AddDraftQuotationDetailDocument = gql`
    mutation AddDraftQuotationDetail($commands: [DraftQuotationDetailAddCommand!]!) {
  addDraftQuotationDetail(commands: $commands) {
    ...DraftQuotationWithDetails
  }
}
    ${DraftQuotationWithDetailsFragmentDoc}`;
export type AddDraftQuotationDetailMutationFn = Apollo.MutationFunction<AddDraftQuotationDetailMutation, AddDraftQuotationDetailMutationVariables>;

/**
 * __useAddDraftQuotationDetailMutation__
 *
 * To run a mutation, you first call `useAddDraftQuotationDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDraftQuotationDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDraftQuotationDetailMutation, { data, loading, error }] = useAddDraftQuotationDetailMutation({
 *   variables: {
 *      commands: // value for 'commands'
 *   },
 * });
 */
export function useAddDraftQuotationDetailMutation(baseOptions?: Apollo.MutationHookOptions<AddDraftQuotationDetailMutation, AddDraftQuotationDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDraftQuotationDetailMutation, AddDraftQuotationDetailMutationVariables>(AddDraftQuotationDetailDocument, options);
      }
export type AddDraftQuotationDetailMutationHookResult = ReturnType<typeof useAddDraftQuotationDetailMutation>;
export type AddDraftQuotationDetailMutationResult = Apollo.MutationResult<AddDraftQuotationDetailMutation>;
export type AddDraftQuotationDetailMutationOptions = Apollo.BaseMutationOptions<AddDraftQuotationDetailMutation, AddDraftQuotationDetailMutationVariables>;
export const UpdateDraftQuotationDocument = gql`
    mutation UpdateDraftQuotation($note: String, $orderStatus: String) {
  updateDraftQuotation(note: $note, orderStatus: $orderStatus) {
    ...DraftQuotationWithDetails
  }
}
    ${DraftQuotationWithDetailsFragmentDoc}`;
export type UpdateDraftQuotationMutationFn = Apollo.MutationFunction<UpdateDraftQuotationMutation, UpdateDraftQuotationMutationVariables>;

/**
 * __useUpdateDraftQuotationMutation__
 *
 * To run a mutation, you first call `useUpdateDraftQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftQuotationMutation, { data, loading, error }] = useUpdateDraftQuotationMutation({
 *   variables: {
 *      note: // value for 'note'
 *      orderStatus: // value for 'orderStatus'
 *   },
 * });
 */
export function useUpdateDraftQuotationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftQuotationMutation, UpdateDraftQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftQuotationMutation, UpdateDraftQuotationMutationVariables>(UpdateDraftQuotationDocument, options);
      }
export type UpdateDraftQuotationMutationHookResult = ReturnType<typeof useUpdateDraftQuotationMutation>;
export type UpdateDraftQuotationMutationResult = Apollo.MutationResult<UpdateDraftQuotationMutation>;
export type UpdateDraftQuotationMutationOptions = Apollo.BaseMutationOptions<UpdateDraftQuotationMutation, UpdateDraftQuotationMutationVariables>;
export const DeleteDraftQuotationDocument = gql`
    mutation DeleteDraftQuotation {
  deleteDraftQuotation
}
    `;
export type DeleteDraftQuotationMutationFn = Apollo.MutationFunction<DeleteDraftQuotationMutation, DeleteDraftQuotationMutationVariables>;

/**
 * __useDeleteDraftQuotationMutation__
 *
 * To run a mutation, you first call `useDeleteDraftQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftQuotationMutation, { data, loading, error }] = useDeleteDraftQuotationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteDraftQuotationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDraftQuotationMutation, DeleteDraftQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDraftQuotationMutation, DeleteDraftQuotationMutationVariables>(DeleteDraftQuotationDocument, options);
      }
export type DeleteDraftQuotationMutationHookResult = ReturnType<typeof useDeleteDraftQuotationMutation>;
export type DeleteDraftQuotationMutationResult = Apollo.MutationResult<DeleteDraftQuotationMutation>;
export type DeleteDraftQuotationMutationOptions = Apollo.BaseMutationOptions<DeleteDraftQuotationMutation, DeleteDraftQuotationMutationVariables>;
export const UpdateDraftQuotationDetailDocument = gql`
    mutation updateDraftQuotationDetail($draftQuotationDetailId: Long!, $wholesaleId: String, $note: String) {
  updateDraftQuotationDetail(
    draftQuotationDetailId: $draftQuotationDetailId
    wholesaleId: $wholesaleId
    note: $note
  ) {
    ...DraftQuotationWithDetails
  }
}
    ${DraftQuotationWithDetailsFragmentDoc}`;
export type UpdateDraftQuotationDetailMutationFn = Apollo.MutationFunction<UpdateDraftQuotationDetailMutation, UpdateDraftQuotationDetailMutationVariables>;

/**
 * __useUpdateDraftQuotationDetailMutation__
 *
 * To run a mutation, you first call `useUpdateDraftQuotationDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftQuotationDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftQuotationDetailMutation, { data, loading, error }] = useUpdateDraftQuotationDetailMutation({
 *   variables: {
 *      draftQuotationDetailId: // value for 'draftQuotationDetailId'
 *      wholesaleId: // value for 'wholesaleId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateDraftQuotationDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftQuotationDetailMutation, UpdateDraftQuotationDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftQuotationDetailMutation, UpdateDraftQuotationDetailMutationVariables>(UpdateDraftQuotationDetailDocument, options);
      }
export type UpdateDraftQuotationDetailMutationHookResult = ReturnType<typeof useUpdateDraftQuotationDetailMutation>;
export type UpdateDraftQuotationDetailMutationResult = Apollo.MutationResult<UpdateDraftQuotationDetailMutation>;
export type UpdateDraftQuotationDetailMutationOptions = Apollo.BaseMutationOptions<UpdateDraftQuotationDetailMutation, UpdateDraftQuotationDetailMutationVariables>;
export const DeleteDraftQuotationDetailDocument = gql`
    mutation deleteDraftQuotationDetail($draftQuotationDetailId: Long!) {
  deleteDraftQuotationDetail(draftQuotationDetailId: $draftQuotationDetailId) {
    ...DraftQuotationWithDetails
  }
}
    ${DraftQuotationWithDetailsFragmentDoc}`;
export type DeleteDraftQuotationDetailMutationFn = Apollo.MutationFunction<DeleteDraftQuotationDetailMutation, DeleteDraftQuotationDetailMutationVariables>;

/**
 * __useDeleteDraftQuotationDetailMutation__
 *
 * To run a mutation, you first call `useDeleteDraftQuotationDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftQuotationDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftQuotationDetailMutation, { data, loading, error }] = useDeleteDraftQuotationDetailMutation({
 *   variables: {
 *      draftQuotationDetailId: // value for 'draftQuotationDetailId'
 *   },
 * });
 */
export function useDeleteDraftQuotationDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDraftQuotationDetailMutation, DeleteDraftQuotationDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDraftQuotationDetailMutation, DeleteDraftQuotationDetailMutationVariables>(DeleteDraftQuotationDetailDocument, options);
      }
export type DeleteDraftQuotationDetailMutationHookResult = ReturnType<typeof useDeleteDraftQuotationDetailMutation>;
export type DeleteDraftQuotationDetailMutationResult = Apollo.MutationResult<DeleteDraftQuotationDetailMutation>;
export type DeleteDraftQuotationDetailMutationOptions = Apollo.BaseMutationOptions<DeleteDraftQuotationDetailMutation, DeleteDraftQuotationDetailMutationVariables>;
export const SubmitQuotationDocument = gql`
    mutation SubmitQuotation($note: String) {
  submitQuotation(note: $note)
}
    `;
export type SubmitQuotationMutationFn = Apollo.MutationFunction<SubmitQuotationMutation, SubmitQuotationMutationVariables>;

/**
 * __useSubmitQuotationMutation__
 *
 * To run a mutation, you first call `useSubmitQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQuotationMutation, { data, loading, error }] = useSubmitQuotationMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSubmitQuotationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitQuotationMutation, SubmitQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitQuotationMutation, SubmitQuotationMutationVariables>(SubmitQuotationDocument, options);
      }
export type SubmitQuotationMutationHookResult = ReturnType<typeof useSubmitQuotationMutation>;
export type SubmitQuotationMutationResult = Apollo.MutationResult<SubmitQuotationMutation>;
export type SubmitQuotationMutationOptions = Apollo.BaseMutationOptions<SubmitQuotationMutation, SubmitQuotationMutationVariables>;
export const CancelQuotationDetailDocument = gql`
    mutation cancelQuotationDetail($quotationId: String!, $quotationDetailId: String!) {
  cancelQuotationDetail(
    quotationId: $quotationId
    quotationDetailId: $quotationDetailId
  ) {
    ...Quotation
  }
}
    ${QuotationFragmentDoc}`;
export type CancelQuotationDetailMutationFn = Apollo.MutationFunction<CancelQuotationDetailMutation, CancelQuotationDetailMutationVariables>;

/**
 * __useCancelQuotationDetailMutation__
 *
 * To run a mutation, you first call `useCancelQuotationDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelQuotationDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelQuotationDetailMutation, { data, loading, error }] = useCancelQuotationDetailMutation({
 *   variables: {
 *      quotationId: // value for 'quotationId'
 *      quotationDetailId: // value for 'quotationDetailId'
 *   },
 * });
 */
export function useCancelQuotationDetailMutation(baseOptions?: Apollo.MutationHookOptions<CancelQuotationDetailMutation, CancelQuotationDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelQuotationDetailMutation, CancelQuotationDetailMutationVariables>(CancelQuotationDetailDocument, options);
      }
export type CancelQuotationDetailMutationHookResult = ReturnType<typeof useCancelQuotationDetailMutation>;
export type CancelQuotationDetailMutationResult = Apollo.MutationResult<CancelQuotationDetailMutation>;
export type CancelQuotationDetailMutationOptions = Apollo.BaseMutationOptions<CancelQuotationDetailMutation, CancelQuotationDetailMutationVariables>;
export const WholesalesDocument = gql`
    query Wholesales {
  wholesales {
    ...Wholesale
  }
}
    ${WholesaleFragmentDoc}`;

/**
 * __useWholesalesQuery__
 *
 * To run a query within a React component, call `useWholesalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholesalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholesalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWholesalesQuery(baseOptions?: Apollo.QueryHookOptions<WholesalesQuery, WholesalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholesalesQuery, WholesalesQueryVariables>(WholesalesDocument, options);
      }
export function useWholesalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholesalesQuery, WholesalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholesalesQuery, WholesalesQueryVariables>(WholesalesDocument, options);
        }
export type WholesalesQueryHookResult = ReturnType<typeof useWholesalesQuery>;
export type WholesalesLazyQueryHookResult = ReturnType<typeof useWholesalesLazyQuery>;
export type WholesalesQueryResult = Apollo.QueryResult<WholesalesQuery, WholesalesQueryVariables>;
export const UpdateQuotationDetailCheckedDocument = gql`
    mutation UpdateQuotationDetailChecked($quotationId: String!, $quotationDetailId: String!, $checked: Int!) {
  updateQuotationDetailChecked(
    quotationId: $quotationId
    quotationDetailId: $quotationDetailId
    checked: $checked
  ) {
    ...Quotation
  }
}
    ${QuotationFragmentDoc}`;
export type UpdateQuotationDetailCheckedMutationFn = Apollo.MutationFunction<UpdateQuotationDetailCheckedMutation, UpdateQuotationDetailCheckedMutationVariables>;

/**
 * __useUpdateQuotationDetailCheckedMutation__
 *
 * To run a mutation, you first call `useUpdateQuotationDetailCheckedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuotationDetailCheckedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuotationDetailCheckedMutation, { data, loading, error }] = useUpdateQuotationDetailCheckedMutation({
 *   variables: {
 *      quotationId: // value for 'quotationId'
 *      quotationDetailId: // value for 'quotationDetailId'
 *      checked: // value for 'checked'
 *   },
 * });
 */
export function useUpdateQuotationDetailCheckedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuotationDetailCheckedMutation, UpdateQuotationDetailCheckedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuotationDetailCheckedMutation, UpdateQuotationDetailCheckedMutationVariables>(UpdateQuotationDetailCheckedDocument, options);
      }
export type UpdateQuotationDetailCheckedMutationHookResult = ReturnType<typeof useUpdateQuotationDetailCheckedMutation>;
export type UpdateQuotationDetailCheckedMutationResult = Apollo.MutationResult<UpdateQuotationDetailCheckedMutation>;
export type UpdateQuotationDetailCheckedMutationOptions = Apollo.BaseMutationOptions<UpdateQuotationDetailCheckedMutation, UpdateQuotationDetailCheckedMutationVariables>;